import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var AddOrEditItemsIA = function AddOrEditItemsIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "7fDMID",
      defaultMessage: [{
        "type": 0,
        "value": "To add or edit products in an order, first go to the "
      }, {
        "children": [{
          "type": 0,
          "value": "order details page"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Then select "
      }, {
        "children": [{
          "type": 0,
          "value": "Edit Order"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ab3w4/",
      defaultMessage: [{
        "type": 0,
        "value": "You can add products by clicking the "
      }, {
        "children": [{
          "type": 0,
          "value": "Add Product"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " button, and remove them by clicking the rubbish bin icon next to each item. You can update item quantities by changing the number in the "
      }, {
        "children": [{
          "type": 0,
          "value": "Qty"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " column."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "UjBG6x",
      defaultMessage: [{
        "type": 0,
        "value": "After making your edits, click "
      }, {
        "children": [{
          "type": 0,
          "value": "Update"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " to save them. You’ll also have the option to leave a note for the retailer, which we highly recommend so they know what’s happening with their order. The retailer will receive an email notification detailing the changes."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Sdx3lz",
      defaultMessage: [{
        "type": 0,
        "value": "To add or edit products in an order, first go to your "
      }, {
        "children": [{
          "type": 0,
          "value": "Orders"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ", and navigate to the "
      }, {
        "children": [{
          "type": 0,
          "value": "order detail"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " page for the order you’d like to change. Then select "
      }, {
        "children": [{
          "type": 0,
          "value": "Edit Order"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Un5qc8",
      defaultMessage: [{
        "type": 0,
        "value": "You can add products by clicking the "
      }, {
        "children": [{
          "type": 0,
          "value": "Add Product"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " button, and remove them by clicking the rubbish bin icon next to each item. You can update item quantities by changing the number in the "
      }, {
        "children": [{
          "type": 0,
          "value": "Qty"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " column."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lyNjZ+",
      defaultMessage: [{
        "type": 0,
        "value": "After making your edits, click "
      }, {
        "children": [{
          "type": 0,
          "value": "Update"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " to save them. You’ll also have the option to leave a note for the retailer, which we highly recommend so they know what’s happening with their order. The retailer will receive an email notification detailing the changes."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};